import classNames from 'classnames';
import React from 'react';

import { ClickOutside } from '../../Clickoutside';
import { TOOLBAR_DATA_HOOK } from '../data-hooks';
import styles from './RicosDesktopToolbarWrapper-scss';
import type { useRicosDesktopToolbarActions } from './UseRicosDesktopToolbarActions';

export const RicosDesktopToolbarWrapper = ({
  type,
  isRTL,
  children,
  onPressEscape,
  onClickOutside,
  moreButton,
}: {
  type: 'floating' | 'static' | 'regular';
  isRTL: boolean;
  children: React.ReactNode;
  onPressEscape: ReturnType<typeof useRicosDesktopToolbarActions>['onPressEscape'];
  onClickOutside: ReturnType<typeof useRicosDesktopToolbarActions>['onClickOutside'];
  moreButton: HTMLButtonElement | null;
}) => {
  return (
    <div
      onKeyDown={e => onPressEscape(e, moreButton)}
      role="toolbar"
      dir={isRTL ? 'rtl' : 'ltr'}
      data-hook={TOOLBAR_DATA_HOOK}
      className={
        (styles.toolbar,
        classNames(styles.toolbar, {
          [styles.toolbarFloating]: type === 'floating',
          [styles.toolbarStatic]: type === 'static',
        }))
      }
    >
      <ClickOutside onClickOutside={onClickOutside} wrapper="div">
        {children}
      </ClickOutside>
    </div>
  );
};
